module.exports = __webpack_public_path__ + "static/media/foto2.3beaff29.png";